import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CostsService } from './costsApi';
import { IPaginationPayload } from '../../interfaces/shared/IPaginationPayload';
import { PaginatedRequests } from '../../interfaces/demo-requests/paginatedStore.type';

const initialState: any = {
    loading: false,
    detailsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchLeoCosts = createAsyncThunk<PaginatedRequests, IPaginationPayload>(
    'costs/tryToFetchLeoCosts',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await CostsService.tryToFetchLeoCosts(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToFetchLeoStats = createAsyncThunk<any, any>(
    'costs/tryToFetchLeoStats',
    async (data: any) => {
        const result = await CostsService.tryToFetchLeoStats(data);
        return result?.data;
    }
);

export const tryToFetchLeoCostsForClient = createAsyncThunk<any, any>(
    'costs/tryToFetchLeoCostsForClient',
    async (data) => {
        const result = await CostsService.tryToFetchLeoCostsForClient(data);
        return result?.data;
    },
);

export const costsSlice = createSlice({
    name: 'costs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchLeoCosts
            .addCase(tryToFetchLeoCosts.pending, (state) => {
                state.loading = true;
            })
            .addCase(tryToFetchLeoCosts.rejected, (state) => {
                state.loading = false;
            })
            .addCase(tryToFetchLeoCosts.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload?.data;
            })

            // tryToFetchLeoStats
            .addCase(tryToFetchLeoStats.pending, (state) => {
                state.loadingStats = true;
            })
            .addCase(tryToFetchLeoStats.rejected, (state) => {
                state.loadingStats = false;
            })
            .addCase(tryToFetchLeoStats.fulfilled, (state, action) => {
                state.loadingStats = false;
                state.stats = action.payload;
            })

            // tryToFetchLeoCostsForClient
            .addCase(tryToFetchLeoCostsForClient.pending, (state) => {
                state.detailsLoading = true;
            })
            .addCase(tryToFetchLeoCostsForClient.rejected, (state) => {
                state.detailsLoading = false;
            })
            .addCase(tryToFetchLeoCostsForClient.fulfilled, (state, action) => {
                state.detailsLoading = false;
                state.clientDetails = action.payload?.data?.elements?.[0];
            })
    },
});

export default costsSlice.reducer;